export const log = (...args) => process.env.REACT_APP_ENVIRONMENT !== 'production' && console.info(args);